module.exports = __webpack_public_path__ + "files/f1ea979b5a12b42465d46a9d49821051.svg";